<template>
  <div class="l-row">
    <form-group label="Agrupador(es) do(s) produto(s)">
      <textarea
        class="form-textarea"
        rows="8"
        v-model="filters.productIds"
        placeholder="997, 998, 999, 1000"/>
      <small class="form-help">Utilize vírgula (,) para múltiplos agrupadores.</small>
    </form-group>

    <form-group label="SKU(s) do(s) produto(s)">
      <textarea
        class="form-textarea"
        rows="8"
        v-model="filters.skus"
        placeholder="SKU123, SKU456, SKU789"/>
      <small class="form-help">Utilize vírgula (,) para múltiplos SKUs.</small>
    </form-group>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      filters: {
        productIds: null,
        skus: null
      }
    }),
    components: {
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// ProductCodes.vue?1dca5bf9